import React from "react";
import { Button } from "reactstrap";
import Select from "react-select";
import NavHeader from "./NavHeader";
import { genId } from "./ids";
import { toastConfirm } from "components/utils/toasts";

// Roster de un equipo: nombre + lista de fe (jugadores) en filas compactas
// (nro de orden | nombre | camiseta | eliminar).
//
// El nombre del equipo es estructura y se guarda con el torneo entero (onRename); la
// lista de fe va por separado (onRosterChange, con la lista completa de jugadores)
// porque los rosters se cargan en paralelo, un equipo por persona, y mandando el
// torneo entero el último en guardar pisaría a los demás.
//
// La camiseta no es del torneo sino del jugador: se edita acá pero se guarda en el
// padrón (onCamisetaChange), así que el cambio se ve en todos los torneos. Se
// persiste al salir del campo, no en cada tecla.
export default function TeamScreen({ team, jugadores, onRename, onRosterChange, onCamisetaChange, onBack }) {
  const renameTeam = (name) => onRename({ ...team, name });

  const addPlayer = () => {
    if (team.players.length >= 14) return;
    onRosterChange([...team.players, { id: genId("player"), name: "", camiseta: "" }]);
  };

  const patchPlayer = (playerId, patch) =>
    onRosterChange(team.players.map((p) => (p.id === playerId ? { ...p, ...patch } : p)));

  const removePlayer = (player) => {
    toastConfirm(
      "¿ Sacar a " + (player.name || "este jugador") + " de la lista de fe ?",
      "Sale de la lista de fe de " + (team.name || "el equipo") + " en este torneo. Sigue en el padrón.",
      () => onRosterChange(team.players.filter((p) => p.id !== player.id))
    );
  };

  const selectJugador = (playerId, option) => {
    if (!option) return;
    // Persistimos el jugador elegido; mantenemos player.id estable (lo usa la lista de fe).
    patchPlayer(playerId, {
      name: option.label,
      value: option.value,
      _id: option.value,
      camiseta: option.camiseta != null ? option.camiseta : "",
      isExcepcion: !!option.isExcepcion,
    });
  };

  // Al salir del campo se guarda la camiseta en el padrón, si cambió y el renglón
  // ya está vinculado a un jugador.
  const guardarCamiseta = (player) => {
    if (!onCamisetaChange || !player.value) return;
    onCamisetaChange(player.value, player.camiseta || "");
  };

  return (
    <div className="screen-slide">
      <NavHeader title={team.name || "Equipo"} subtitle={team.players.length + "/14 jugadores"} onBack={onBack} />

      <div className="card mb-3">
        <div className="card-body">
          <div className="form-group mb-0">
            <label className="font-weight-bold" style={{ fontSize: "0.875rem" }}>
              Nombre del Equipo
            </label>
            <input
              type="text"
              className="form-control form-control-lg"
              value={team.name}
              onChange={(e) => renameTeam(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="sub-section-title mb-0">Lista de Fe (máx 14)</span>
        <Button className="btn-arhock btn-sm my-0" onClick={addPlayer} disabled={team.players.length >= 14}>
          + Agregar Jugador
        </Button>
      </div>

      {team.players.length === 0 ? (
        <p className="text-muted text-center py-3" style={{ fontSize: "0.875rem" }}>
          No hay jugadores en la lista. Tocá &quot;Agregar Jugador&quot; para empezar.
        </p>
      ) : (
        <>
          <div className="roster-head">
            <span className="roster-row-num">#</span>
            <span className="roster-row-nombre">Nombre y Apellido</span>
            <span className="roster-row-camiseta">Camiseta</span>
            <span className="roster-head-spacer" />
          </div>
          {team.players.map((player, index) => (
            <div className="roster-row" key={player.id}>
              <span className="roster-row-num">{index + 1}</span>
              <div className="roster-row-nombre">
                <Select
                  isSearchable={true}
                  placeholder="Buscá un jugador..."
                  classNamePrefix="react-select"
                  name={"selectJugador-" + player.id}
                  value={player.name ? { value: player.value || player.id, label: player.name } : null}
                  onChange={(option) => selectJugador(player.id, option)}
                  options={jugadores}
                  noOptionsMessage={() => "Sin jugadores"}
                />
              </div>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                className="form-control roster-row-camiseta"
                placeholder="#"
                aria-label="Camiseta"
                value={player.camiseta}
                onChange={(e) => patchPlayer(player.id, { camiseta: e.target.value })}
                onBlur={() => guardarCamiseta(player)}
              />
              <button
                type="button"
                className="drill-row-delete roster-row-delete"
                aria-label="Eliminar jugador"
                onClick={() => removePlayer(player)}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6M14 11v6" />
                </svg>
              </button>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
